<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-form :form="form" class="table-page-search-wrapper">
        <a-row>
          <a-col :span="24" v-if="sellContract">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.project }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="货物" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.product_name }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.number }} [ {{ sellContract.name }}]
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              银承/商承付款信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input style="width: 40%" v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="票据种类" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'bill_type',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in billTypeList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="票据编码" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bill_code', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="承兑人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['acceptor', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="出票日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['issue_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="出票日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="票面金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['face_value', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'face_value_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="票据到期日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['maturity_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="票据到期日"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="贴现费率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['discount_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="贴现费率"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="到期可用" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_available_at_expiry', { initialValue: false, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="担保方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['guarantee_method', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['margin_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'margin_amount_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金起止日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-range-picker @change="time" format="YYYY-MM-DD" style="width: 100%" v-decorator="['date', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金利率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['margin_interest_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="保证金利率"/> %
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开启贴现" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-switch
                @change="openDiscountingChange"
                checked-children="开"
                un-checked-children="关"
                v-decorator="['is_open_discounting', {initialValue: false, valuePropName: 'checked', rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :offset="1" :span="23" v-if="openDiscounting">
            <a-divider orientation="left">
              贴现
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="openDiscounting">
            <a-form-item label="贴现主体" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="discountingCorporationFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'discounting_corporation_id',
                  {
                    rules: [
                      { required: false, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入公司名称"
                :default-active-first-option="false"
                @search="this.corporationSearch"
              >
                <a-spin v-if="discountingCorporationFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in discountingCorporationList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="openDiscounting">
            <a-form-item label="贴现银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="bankFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'discounting_bank_id',
                  {
                    rules: [
                      { required: false, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入银行名称"
                :default-active-first-option="false"
                @search="this.bankSearch"
              >
                <a-spin v-if="bankFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in bankList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="openDiscounting">
            <a-form-item label="贴现日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['discounting_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="贴现日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="openDiscounting">
            <a-form-item label="贴现费用" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['discounting_amount', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'discounting_amount_currency',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="openDiscounting">
            <a-form-item label="承担利息主体" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['interest_payer', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开启到期付款" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-switch
                @change="openMaturityPayChange"
                checked-children="开"
                un-checked-children="关"
                v-decorator="['is_open_maturity_pay', {initialValue: false, valuePropName: 'checked', rules: [{required: true, message: '必填项，请填写信息'}]}]"
              />
            </a-form-item>
          </a-col>
          <a-col :offset="1" :span="23" v-if="openMaturityPay">
            <a-divider orientation="left">
              到期付款
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="openMaturityPay">
            <a-form-item label="到期付款日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['maturity_pay_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="到期付款日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="openMaturityPay">
            <a-form-item label="到期付款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['maturity_pay_amount', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'maturity_pay_amount_currency',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-row>
              <a-col span="4" :offset="8">
                <a-button type="primary" html-type="submit" @click="handleSubmit" :loading="submitting">提交</a-button>
              </a-col>
              <a-col span="12">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
import moment from 'moment'
import {
  lc_application_list
} from '@/api/trade_credit_letter'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { bank_list } from '@/api/trade_bank'
import { sell_contract_list } from '@/api/trade_sell_contract'
import {
  bank_commercial_acceptance_list,
  bank_commercial_acceptance_update
} from '@/api/trade_bank_commercial_acceptance'
import { corporation_list } from '@/api/trade_corporation'
const fields = ['business_no', 'bill_type', 'bill_code', 'acceptor', 'issue_date', 'face_value', 'face_value_currency',
  'maturity_date', 'discount_rate', 'is_available_at_expiry', 'guarantee_method', 'margin_amount', 'margin_amount_currency',
  'margin_interest_rate', 'date', 'is_open_discounting', 'discounting_corporation_id', 'discounting_bank_id', 'discounting_date', 'discounting_amount',
  'discounting_amount_currency', 'interest_payer', 'is_open_maturity_pay', 'maturity_pay_date', 'maturity_pay_amount', 'maturity_pay_amount_currency']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.corporationSearch = debounce(this.handleCorporationSearch, 800)
    this.bankSearch = debounce(this.handleBankSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      sellContract: undefined,
      mdl: undefined,
      id: 0,
      billTypeList: this.$Dictionaries.trade_bank_commercial_acceptance_type,
      currency: this.$Dictionaries.currency,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      contractTypes: this.$Dictionaries.contractTypes,
      bankServicesTypeList: this.$Dictionaries.bank_services_types,
      letterCreditTypeList: this.$Dictionaries.letter_credit_types,
      marginSourceList: this.$Dictionaries.margin_resources,
      lcTypeList: this.$Dictionaries.trade_lc_types,
      data: undefined,
      loading: false,
      submitting: false,
      bankFetching: false,
      discountingCorporationFetching: false,
      discountingCorporationList: [],
      bankList: [],
      openDiscounting: false,
      openMaturityPay: false,
      otherData: {
        margin_start_date: undefined,
        margin_end_date: undefined
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      }
    }
  },
  mounted () {
    this.loadSellContractInfo()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    selectedSellContract () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.sell_contract.name + '[' + this.data.sell_contract.number + ']'
    },
    selectedProject () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.project
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      this.otherData.margin_start_date = dateStrings[0]
      this.otherData.margin_end_date = dateStrings[1]
    },
    loadSellContractInfo () {
      this.loading = true
      console.log('开始加载。。。。。')
      lc_application_list({ id: this.$route.query.lc_application_id })
        .then(res => {
          this.mdl = res.data.entries[0] || []
        }).finally(() => {
        if (this.mdl !== undefined && this.mdl['sell_contract_id'] !== undefined) {
          sell_contract_list({ id: this.mdl['sell_contract_id'] }).then(res => {
            if (res !== undefined && res.code === 1000 && res.data !== undefined && res.data.entries !== undefined && res.data.entries.length > 0) {
              this.sellContract = res.data.entries[0]
            }
          }).finally(() => {
            this.loading = false
          })
          this.id = this.$route.params.id
          bank_commercial_acceptance_list({ id: this.$route.params.id }).then(res => {
            if (res !== undefined && res.code === 1000 && res.data !== undefined && res.data.entries !== undefined && res.data.entries.length > 0) {
              const currentData = res.data.entries[0]
              if (currentData) {
                this.openDiscounting = currentData.is_open_discounting
                this.openMaturityPay = currentData.is_open_maturity_pay
                this.loadEditInfo(currentData)
              }
            }
          })
        } else {
          this.loading = false
        }
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          this.loading = true
          this.submitting = true
          values['date'] = undefined
          values['margin_start_date'] = this.otherData.margin_start_date
          values['margin_end_date'] = this.otherData.margin_end_date
          bank_commercial_acceptance_update(values, this.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
                console.log(res, '修改成功')
              }
            }).finally(() => {
              this.loading = false
              this.submitting = false
          })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        formData.date = [ moment(data.margin_start_date), moment(data.margin_end_date) ]
        formData.bill_type = '' + formData.bill_type
        console.log('formData', formData)
        form.setFieldsValue(formData)
      }).finally(() => {
        if (this.openDiscounting) {
          if (data.discounting_corporation_id) {
            this.corporationLoadList({ id: data.discounting_corporation_id })
          }
          if (data.discounting_bank_id) {
            this.bankLoadList({ id: data.discounting_bank_id }, 1)
          }
        }
      })
    },
    openDiscountingChange (value) {
      this.openDiscounting = value
    },
    openMaturityPayChange (value) {
      this.openMaturityPay = value
    },
    handleCorporationSearch (value) {
      this.corporationLoadList({ name: value })
    },
    corporationLoadList (parameter) {
      this.discountingCorporationFetching = true
      corporation_list(parameter).then((res) => {
        this.discountingCorporationList = res.data.entries || []
      }).finally(() => {
        this.discountingCorporationFetching = false
      })
    },
    handleBankSearch (value) {
      this.bankLoadList({ name: value }, 1)
    },
    bankLoadList (parameter, index) {
      if (index === 1) {
        this.bankFetching = true
      }
      bank_list(parameter).then((res) => {
        if (index === 1) {
          this.bankList = res.data.entries || []
        }
      }).finally(() => {
        if (index === 1) {
          this.bankFetching = false
        }
      })
    }
  }
}
</script>
